import React from 'react';

const ContactUs = () => {
    return (
        <div>
            hjgkh
        </div>
    );
};

export default ContactUs;